'use client';
import React, { useState } from 'react';
import { usePathname } from 'next/navigation';

const appRoutes = ['/dashboard', '/settings'];

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const pathname = usePathname();

  if (appRoutes.some((route) => pathname.startsWith(route))) {
    return null;
  }

  return (
    <nav className="sticky top-0 z-50 bg-white/80 backdrop-blur-lg border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <a href="/" className="flex items-center space-x-2">
              <svg className="w-8 h-8 text-primary-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4" />
              </svg>
              <span className="font-bold text-xl">ConfigSync</span>
            </a>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <a href="/docs" className="text-gray-600 hover:text-gray-900">Documentation</a>
            <a href="/cheatsheet" className="text-gray-600 hover:text-gray-900">Cheatsheet</a>
            <a href="/blog" className="text-gray-600 hover:text-gray-900">Blog</a>
            <a href="/plugins" className="text-gray-600 hover:text-gray-900">Plugins</a>
            <a href="/pricing" className="text-gray-600 hover:text-gray-900">Pricing</a>
            <a href="/login" className="text-gray-600 hover:text-gray-900 font-medium">Log In</a>
            <a href="/signup" className="bg-primary-700 text-white px-6 py-2 rounded-lg hover:bg-primary-800 transition font-semibold">
              Sign Up
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-600 hover:text-gray-900"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                {isMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div className="md:hidden border-t border-gray-200">
          <div className="px-2 pt-2 pb-3 space-y-1">
            <a href="/docs" className="block px-3 py-2 text-gray-600 hover:text-gray-900">Documentation</a>
            <a href="/cheatsheet" className="block px-3 py-2 text-gray-600 hover:text-gray-900">Cheatsheet</a>
            <a href="/blog" className="block px-3 py-2 text-gray-600 hover:text-gray-900">Blog</a>
            <a href="/plugins" className="block px-3 py-2 text-gray-600 hover:text-gray-900">Plugins</a>
            <a href="/pricing" className="block px-3 py-2 text-gray-600 hover:text-gray-900">Pricing</a>
            <a href="/login" className="block px-3 py-2 text-gray-600 hover:text-gray-900 font-medium">Log In</a>
            <a href="/signup" className="block w-full text-center px-3 py-2 bg-primary-700 text-white rounded-lg font-semibold">
              Sign Up
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}